// extracted by mini-css-extract-plugin
export default {"btn":"personalinfo_btn__ECb8s","error":"personalinfo_error__AzwpV","label":"personalinfo_label__NYALl"};